import BoxIcon from './BoxIcon';

export default BoxIcon;
